import { render, staticRenderFns } from "./MatriksBulananKebidanan.vue?vue&type=template&id=5dad36b4&scoped=true&"
import script from "./MatriksBulananKebidanan.vue?vue&type=script&lang=ts&"
export * from "./MatriksBulananKebidanan.vue?vue&type=script&lang=ts&"
import style0 from "./MatriksBulananKebidanan.vue?vue&type=style&index=0&id=5dad36b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dad36b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
